import WriteoffInvoicing from './writeoff_invoicing'
import WriteoffRelatedInvoicing from './writeoff_related_invoicing'
import WriteoffDistribution from './writeoff_distribution'

export default {
  modules: {
    WriteoffInvoicing,
    WriteoffRelatedInvoicing,
    WriteoffDistribution
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/distribution_writeoff/index.js